// extracted by mini-css-extract-plugin
export var alternate = "_c-j";
export var black = "_c-6";
export var blue = "_c-f";
export var blueLight = "_c-e";
export var brand = "_c-8";
export var darkMode = "_c-b";
export var error = "_c-a";
export var gray = "_c-5";
export var grayBlue = "_c-d";
export var iconWrapper = "_c-3";
export var inactive = "_c-7";
export var indigo = "_c-g";
export var orange = "_c-i";
export var pink = "_c-h";
export var primary = "_c-0";
export var purple = "_c-9";
export var success = "_c-4";
export var warning = "_c-c";
export var white = "_c-1";
export var whiteSuccess = "_c-2";